import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { DropTarget } from 'react-dnd';
import Chip from 'material-ui/Chip';
import { TaskCard } from './TaskCard';
import { grey200 } from 'material-ui/styles/colors';
var dropTarget = {
    drop: function (props, monitor) {
        var task = monitor.getItem().task;
        if (task && task.canDrop(props.status.id)) {
            task.setStatus(props.status.id);
        }
    }
};
var styles = {
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        margin: '.5rem',
        backgroundColor: grey200
    },
    headerContainer: {
        backgroundColor: 'white',
        padding: '10px',
        borderLeft: '1px solid #e0e0e0',
        borderRight: '1px solid #e0e0e0',
        borderBottom: '1px solid #e0e0e0',
        borderRadius: '3px 3px 0px 0px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    itemContainer: {
        backgroundColor: 'transparent',
    },
    header: {
        color: 'white',
        borderRadius: '5px',
        fontSize: '11px',
        height: '20px',
        lineHeight: '20px',
        cursor: 'pointer'
    },
    priorityBadges: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        maxWidth: '300px'
    },
    collapsed: {
        container: {
            width: '40px',
            height: '100vh',
            margin: '.5rem',
            backgroundColor: 'white',
            padding: '5px',
            paddingTop: '15px',
            borderLeft: '1px solid #e0e0e0',
            borderRight: '1px solid #e0e0e0',
            borderBottom: '1px solid #e0e0e0',
            borderRadius: '3px 3px 0px 0px',
            cursor: 'pointer'
        }
    }
};
var IndependentColumnScrolling = function (styleToApply) {
    return tslib_1.__assign({}, styleToApply, { itemContainer: tslib_1.__assign({}, styleToApply.itemContainer, {
            minHeight: 'calc(100vh - 350px)',
            maxHeight: 'calc(100vh - 350px)',
            overflowY: 'auto',
        }) });
};
function ColumnSummary(_a) {
    var tasks = _a.tasks, store = _a.store;
    if (tasks.length === 0) {
        return null;
    }
    function setPriorityFilter(priority) {
        store.filter.setValue('priority', priority);
    }
    var priorities = Array.from(new Set(tasks
        .sort(function (a, b) { return a.priority > b.priority ? 1 : 0; })
        .map(function (t) { return t.ticketPriority; })));
    var priorityBadges = priorities.map(function (p) {
        var style = tslib_1.__assign({}, styles.header, { cursor: 'pointer', backgroundColor: tasks.find(function (t) { return t.ticketPriority === p; }).priorityColor });
        return (React.createElement(Chip, { key: p, style: tslib_1.__assign({ margin: '0 .25em' }, style), labelStyle: style },
            React.createElement("div", { onClick: function () { return setPriorityFilter(p); } }, p + "(" + tasks.filter(function (t) { return t.ticketPriority === p; }).length + ")")));
    });
    return React.createElement(React.Fragment, null, priorityBadges);
}
var TaskBoardColumn = /** @class */ (function (_super) {
    tslib_1.__extends(TaskBoardColumn, _super);
    function TaskBoardColumn(props) {
        var _this = _super.call(this, props) || this;
        _this.handleHeaderClick = function (e) {
            e.preventDefault();
            _this.setState(function (state) { return ({
                collapsed: !state.collapsed
            }); }, function () {
                window.localStorage.setItem(_this.columnKey, JSON.stringify(_this.state));
            });
        };
        var savedState = JSON.parse(window.localStorage.getItem(_this.columnKey));
        if (savedState) {
            _this.state = savedState;
        }
        else {
            _this.state = {
                collapsed: false
            };
        }
        return _this;
    }
    Object.defineProperty(TaskBoardColumn.prototype, "columnKey", {
        get: function () {
            return "boardy.column" + this.props.status.id + ".state";
        },
        enumerable: true,
        configurable: true
    });
    TaskBoardColumn.prototype.render = function () {
        var _a = this.props, status = _a.status, tasks = _a.tasks, connectDropTarget = _a.connectDropTarget;
        var currentStyles = this.props.preferencesStore.independentColumnScrolling.value
            ? IndependentColumnScrolling(styles)
            : styles;
        var headerContainerStyle = tslib_1.__assign({}, currentStyles.headerContainer, { borderTop: '3px solid' + status.color });
        var headerStyle = tslib_1.__assign({}, currentStyles.header, { backgroundColor: status.color, fontWeight: 'bold' });
        if (this.state.collapsed) {
            var collapsedContainerStyle = tslib_1.__assign({}, styles.collapsed.container, { borderTop: '3px solid' + status.color });
            return (React.createElement("div", { style: collapsedContainerStyle, onClick: this.handleHeaderClick },
                React.createElement("div", { style: tslib_1.__assign({}, headerStyle, { display: 'flex', flexDirection: 'row', transform: 'rotate(90deg)', translate: '0 1rem' }) },
                    React.createElement(Chip, { style: { marginRight: '.5rem' }, labelStyle: tslib_1.__assign({}, headerStyle) }, status.name),
                    React.createElement(ColumnSummary, { tasks: tasks, store: this.props.taskStore }))));
        }
        return connectDropTarget(React.createElement("div", { style: currentStyles.container },
            React.createElement("div", { style: headerContainerStyle },
                React.createElement("div", { onClick: this.handleHeaderClick },
                    React.createElement(Chip, { style: tslib_1.__assign({}, headerStyle), labelStyle: headerStyle }, status.name)),
                React.createElement("div", { style: styles.priorityBadges },
                    React.createElement(ColumnSummary, { tasks: tasks, store: this.props.taskStore }))),
            React.createElement("div", { style: currentStyles.itemContainer }, tasks.map(function (i) { return React.createElement(TaskCard, { key: i.id, color: status.color, task: i }); }))));
    };
    TaskBoardColumn = tslib_1.__decorate([
        DropTarget('scrumBoardItem', dropTarget, function (connect, monitor) { return ({
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); }),
        observer
    ], TaskBoardColumn);
    return TaskBoardColumn;
}(React.Component));
export { TaskBoardColumn };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskBoardColumn.tsx
// module id = 731
// module chunks = 0